import { isEmptyJsonObject } from "../../../../../common/utils/helper";
import { callWithCustomAuth } from "../../../../../common/modules/http.bridge.client";

const simpleConnectionTest = async (currentData, credObj) => {
  try {
    await callWithCustomAuth(
      `${currentData.oktaBaseUrl}/api/v1/apps`,
      "GET",
      {
        key: "Authorization",
        value: credObj.oktaToken,
      },
      {}
    );
    return true;
  } catch (error) {
    return false;
  }
};

/** OKTA AUTH */
export const getHeaderCredentials = (currentData, creds) => {
  let credObj = {};

  if (currentData.selectedOktaAuthOption === "WizardHeaderAuth") {
    credObj = {
      oktaToken: "SSWS " + currentData.oktaToken,
    };
  } else {
    const cred = creds.find((c) => c.id === currentData.oktaCredential.value);
    credObj = {
      oktaToken:
        cred.data?.headers && cred.data?.headers.length > 0
          ? cred.data?.headers[0].value
          : "undefined",
    };
  }
  return credObj;
};

export const oktaCredentialsNotBeEmpty = async (
  currentData,
  jiraAssetData,
  creds
) => {
  let status = true;
  let message = "";
  //console.log("userNamePasswordNotEmpty",currentData?.selectedAuthOption)
  if (currentData?.selectedAuthOption === "") {
    status = false;
    message = "Select or create a new credential.";
  } else if (currentData?.selectedOktaAuthOption === "CredentialPicker") {
    if (isEmptyJsonObject(currentData?.credential)) {
      status = false;
      message = "Select a credential.";
    }
  } else if (currentData?.selectedOktaAuthOption === "WizardHeaderAuth") {
    if (currentData?.oktaToken === "") {
      status = false;
      message = "Create a new credential.";
    }
  } else {
    status = false;
    message = "Please provide a Credential";
  }
  //return input validation
  if (!status) {
    return {
      valid: status,
      message: message,
    };
  }

  //try connect
  const connected = await simpleConnectionTest(
    currentData,
    getHeaderCredentials(currentData, creds)
  );
  return {
    valid: connected,
    message: connected
      ? ""
      : "Could not connect with credentials, please verify the credentials entered.",
  };
};

export const configurationCheck = async (currentData, jiraAssetData, creds) => {
  let status = true;
  let message = "";
  if (jiraAssetData.selectedAssetSchema === null || jiraAssetData.selectedAssetSchema === undefined || jiraAssetData.selectedAssetSchema === "") {
    return {
      valid: false,
      message: "Please select one Asset Schema"
    };
  }

  if (!currentData?.oktaConfig) {
    status = false;
    message = "Please select at least one option from the Okta checkboxes.";
  } else {
    status = false;
    message = "Please select at least one option from the Okta checkboxes.";
    for (let key in currentData.oktaConfig) {
      if (
        currentData?.oktaConfig.hasOwnProperty(key) &&
        currentData?.oktaConfig[key].checked === true
      ) {
        status = true;
        message = "";
        break;
      }
    }
  }

  return {
    valid: status,
    message: message,
  };
};
